import type { TownsquareComment } from '../../types';

export const isTownsquareComment = (entity: any): entity is TownsquareComment =>
	entity.__typename === 'TownsquareComment';

export const getTownsquareCommentLink = (comment: TownsquareComment): string | null =>
	comment?.url ?? null;
